<script setup lang="ts">
import SmallLogo from "@/assets/images/pages/SmallLogo.vue";

withDefaults(
  defineProps<{
    height?: string
    svgSize?: string
  }>(),
  {
    height: "100vh",
    svgSize: "110",
  },
);
</script>

<template>
  <section
    class="flex justify-center items-center"
    :style="{ height: height }"
  >
    <SmallLogo
      class="rotate"
      :size="svgSize"
    />
  </section>
</template>

<style scoped>
.rotate {
  animation: rotate 4s linear infinite; /* adjust duration and timing function as needed */
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
